import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=7cb8e3d6&scoped=true"
import script from "./TicketDetail.vue?vue&type=script&lang=js"
export * from "./TicketDetail.vue?vue&type=script&lang=js"
import style1 from "./TicketDetail.vue?vue&type=style&index=1&id=7cb8e3d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb8e3d6",
  null
  
)

export default component.exports